module.exports = __webpack_public_path__ + "media/images/new_home/apple_maps_logo_white-d5c92ffb2b6e25923c6a6a8ad575e569.png";